import React from 'react';

const ChevronRight = () => {
  return <svg width="11" height="10" viewBox="5 5 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="ChevronRight">
      <path id="Vector" fillRule="evenodd" clipRule="evenodd"
            d="M7.79279 14.7103C7.60532 14.5228 7.5 14.2685 7.5 14.0033C7.5 13.7382 7.60532 13.4839 7.79279 13.2963L11.0858 10.0033L7.79279 6.71034C7.61063 6.52173 7.50983 6.26913 7.51211 6.00694C7.51439 5.74474 7.61956 5.49393 7.80497 5.30852C7.99038 5.12311 8.24119 5.01794 8.50339 5.01566C8.76558 5.01338 9.01818 5.11418 9.20679 5.29634L13.2068 9.29634C13.3943 9.48386 13.4996 9.73817 13.4996 10.0033C13.4996 10.2685 13.3943 10.5228 13.2068 10.7103L9.20679 14.7103C9.01926 14.8978 8.76495 15.0031 8.49979 15.0031C8.23462 15.0031 7.98031 14.8978 7.79279 14.7103Z"
            fill="black" fillOpacity="0.3"/>
    </g>
  </svg>
}

export default ChevronRight;
